import { useUser } from "@accredo/fe-shared/hooks/user.js";
import policy from "../../policies/DocumentTypePolicy.js";

export function useDocumentTypePermissions() {
  const { user } = useUser();
  return {
    canCreate: () => policy.create({ user }),
    canEdit: () => policy.update({ user }),
    canDelete: () => policy.delete({ user }),
  };
}
